import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  min-width: 1080px;
  padding: 3px;
  box-shadow: 0 0 15px 0 rgb(0 0 0 / 10%);
  border-top: 2px solid rgba(0, 0, 0, 0.1);
`;

export const ButtonWrap = styled.div`
  flex: 1 1;
  text-align: center;

  button {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
    border-radius: 3px;
    padding: 6px;
    font-size: 1em;
    color: rgba(0, 0, 0, 0.6);
    background: rgba(0, 0, 0, 0.1);
    transition: all 0.1s ease;
    cursor: pointer;
    outline: none;
    appearance: none;
  }

  button:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const Wrapper = styled.div`
  flex: 1.5 1;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
  text-align: center;
  margin-bottom: 0;
  display: flex;

  input {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    background: #fff;
    padding: 5px 7px;
    font-size: inherit;
    font-weight: 400;
    outline: none;
  }
`;

export const PageInfo = styled.div`
  display: inline-block;
  margin: 3px 10px;
  white-space: nowrap;

  div {
    display: inline-block;
  }

  input {
    width: 70px;
    text-align: center;
    margin: 0 10px;
  }
`;

export const PageSizeSelect = styled.div`
  margin: 3px 10px;

  select {
    padding: 5px 7px;
    margin: 0;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    background: #fff;
    font-size: inherit;
    font-weight: 400;
    outline: none;
    color: inherit;
    touch-action: manipulation;

    option {
      display: block;
      min-height: 1.2em;
      padding: 0 2px 1px;
      font-weight: normal;
      white-space: nowrap;
    }
  }
`;
